module.exports = __webpack_public_path__ + "static/media/epark-vest.11e49ccd.svg";